module.exports = __webpack_public_path__ + "static/img/zhong24.cbc18ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong24.png
// module id = wNOj
// module chunks = 16